/**
 * @generated SignedSource<<ad63307805881314dcd61bc01eb22db6>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type headerAllMenuQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"headerAllMenuColumnistsQuery" | "headerAllMenuFocusQuery" | "headerAllMenuHighlightsQuery" | "headerAllMenuSectionAppConfigQuery" | "headerAllMenuTopicsQuery">;
  readonly " $fragmentType": "headerAllMenuQuery";
};
export type headerAllMenuQuery$key = {
  readonly " $data"?: headerAllMenuQuery$data;
  readonly " $fragmentSpreads": FragmentRefs<"headerAllMenuQuery">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "headerAllMenuQuery",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerAllMenuTopicsQuery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerAllMenuColumnistsQuery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerAllMenuFocusQuery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerAllMenuHighlightsQuery"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "headerAllMenuSectionAppConfigQuery"
    }
  ],
  "type": "Query",
  "abstractKey": null
};

(node as any).hash = "1ecf5fcd85d6e8408270ff6b9ba5273a";

export default node;
